import { TENANTS } from "../../../constants"

export const SAMSUNG_SHOP_REDIRECT_COUNTDOWN_TENANTS = [
  TENANTS.SAMSUNG_BE,
  TENANTS.SAMSUNG_NL,
  TENANTS.SAMSUNG_ES_APZ,
  TENANTS.SAMSUNG_ES,
  TENANTS.SAMSUNG_PT,
  TENANTS.SAMSUNG_IT
]

export const hasSamsungShopRedirectCountdown = (tenant) => SAMSUNG_SHOP_REDIRECT_COUNTDOWN_TENANTS.includes(tenant)
